import useHttpPost from "./useHttpPost";

function usePostTransaction(target) {
  return useHttpPost("vehicletype", "post", {}, target);
}

export default usePostTransaction;
